import { gql } from "@apollo/client";

export const AUTO_GENERATE_QUESTION_MUTATION = gql`
  mutation AutoGenerateQuestion(
    $subject: ID!
    $yearGroup: ID!
    $includeSourceText: Boolean!
    $specificFocus: String
    $questionType: String!
  ) {
    generatedQuestion(
      subject: $subject
      questionType: $questionType
      yearGroup: $yearGroup
      includeSourceText: $includeSourceText
      specificFocus: $specificFocus
    ) {
      success
      message
      questionText
      sourceText
      suggestedTags
      options {
        text
        isCorrect
      }
    }
  }
`;

export const ADD_QUESTION_TAGS_MUTATION = gql`
  mutation AddQuestionTags($question: ID!, $tags: [String!]!) {
    addQuestionTags(question: $question, tags: $tags) {
      success
      message
      question {
        id
        tags {
          id
          tag
        }
      }
    }
  }
`;

export const CREATE_QUESTION_MUTATION = gql`
  mutation CreateQuestion(
    $subject: ID!
    $yearGroup: ID!
    $tags: [String]!
    $questionText: String!
    $questionType: String!
    $sourceText: String
    $images: [Upload]
  ) {
    createQuestion(
      subject: $subject
      yearGroup: $yearGroup
      tags: $tags
      questionText: $questionText
      questionType: $questionType
      sourceText: $sourceText
      images: $images
    ) {
      success
      message
      question {
        id
        questionType
        educationLevel {
          id
          level
          yearGroups {
            id
            yearGroup
          }
        }
        yearGroup {
          id
          yearGroup
        }
        subject {
          id
          name
        }
        tags {
          id
          tag
        }
        questionText
        sourceText
        sourceImages {
          id
          fileUrl
          description
        }
        isPublished
        isComplete
        options {
          id
          text
          isCorrect
        }
        markScheme {
          id
          name
          tags {
            id
            tag
          }
          modelAnswerGuidance
          objectives {
            id
            marks
            additionalInstructions
            assessmentObjective {
              id
              focusArea
              description
              identifier
              subject {
                name
              }
            }
            levels {
              minMark
              maxMark
              levelCriteria
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_QUESTION_MUTATION = gql`
  mutation UpdateQuestion(
    $question: ID!
    $questionText: String!
    $questionType: String!
    $tags: [String]!
    $sourceText: String
    $markScheme: String
    $images: [Upload]
  ) {
    updateQuestion(
      question: $question
      questionText: $questionText
      questionType: $questionType
      tags: $tags
      sourceText: $sourceText
      markScheme: $markScheme
      images: $images
    ) {
      success
      message
      question {
        id
        questionType
        educationLevel {
          id
          level
          yearGroups {
            id
            yearGroup
          }
        }
        yearGroup {
          id
          yearGroup
        }
        subject {
          id
          name
        }
        tags {
          id
          tag
        }
        questionText
        sourceText
        sourceImages {
          id
          file
          description
        }
        isPublished
        isComplete
        options {
          id
          text
          isCorrect
        }
        markScheme {
          id
          name
          tags {
            id
            tag
          }
          modelAnswerGuidance
          objectives {
            id
            marks
            additionalInstructions
            assessmentObjective {
              id
              focusArea
              description
              identifier
              subject {
                name
              }
            }
            levels {
              minMark
              maxMark
              levelCriteria
            }
          }
        }
      }
    }
  }
`;

export const DELETE_SOURCE_IMAGE_MUTATION = gql`
  mutation DeleteSourceImage($sourceImages: [ID!]!) {
    deleteSourceImage(sourceImages: $sourceImages) {
      success
      message
      question {
        id
        sourceImages {
          id
          fileUrl
          description
        }
      }
    }
  }
`;

export const SUGGEST_MARK_SCHEME_MUTATION = gql`
  mutation SuggestMarkScheme($question: ID!, $aoConfig: JSONString!) {
    suggestMarkScheme(question: $question, aoConfig: $aoConfig) {
      success
      message
      modelAnswerGuidance
      suggestedAos {
        identifier
        levels {
          minMark
          maxMark
          levelCriteria
        }
      }
    }
  }
`;

export const SUBMIT_REVIEW_MUTATION = gql`
  mutation SubmitReview($question: ID!, $rating: Float!, $comment: String) {
    submitReview(question: $question, rating: $rating, comment: $comment) {
      success
      message
      question {
        id
        rating {
          rating
          count
        }
        userReview {
          rating
          comment
        }
      }
    }
  }
`;

export const EXTRACT_QUESTIONS_AND_MARKSCHEMES_MUTATION = gql`
  mutation ExtractQuestions(
    $files: [Upload]!
    $subject: ID!
    $yearGroup: ID!
    $includesMarkScheme: Boolean!
    $singleQuestion: Boolean!
    $quizGroup: ID
    $assignment: ID
  ) {
    extractQuestions(
      files: $files
      subject: $subject
      yearGroup: $yearGroup
      includesMarkScheme: $includesMarkScheme
      singleQuestion: $singleQuestion
      quizGroup: $quizGroup
      assignment: $assignment
    ) {
      success
      message
      job {
        id
        message
      }
    }
  }
`;
